import ContentLayout from "../../layout/contentLayout";
import PeopleIcon from "@mui/icons-material/People";
import Content from "./content";
/**
 * CustomerOrganization
 *
 * صفحه نمایش خدمات مشتریان در داشبورد.
 * این کامپوننت شامل:
 * - استفاده از ContentLayout برای ساختار صفحه
 * - آیکون نماینده مشتریان (PeopleIcon)
 * - عنوان صفحه "خدمات مشتریان"
 * - محتوا با استفاده از کامپوننت Content
 *
 * ویژگی‌ها:
 * - isContainerFluid برای استفاده از پهنای کامل کانتینر
 *
 * @returns JSX.Element
 */
const CustomerOrganization = () => {
  return (
    <ContentLayout icon={<PeopleIcon />} title="خدمات مشتریان" isContainerFluid>
      <Content />
    </ContentLayout>
  );
};

export default CustomerOrganization;
